import './DraftTag.css';

function DraftTag(props) {
    return (
        <div className={`draft-tag draft-tag-${props.type}`}>Draft</div>
    )
}

export default DraftTag;